export const ACCOUNT_REGISTRATION_FORM = 'accountRegistrationForm';
export const CLIENT_FORM = 'client';
export const CLIENT_PROVIDENT_FUND_FORM = 'clientProvidentFundForm';
export const CURRENT_CLIENT_FORM = 'currentClient';
export const PAYROLL_RULES_GROUP_FORM = 'payrollRulesGroup';
export const PAYROLL_RULES_GROUP_PAYMENT_ON_WEEKEND_CASE_FORM = 'payrollRulesPaymentOnWeekendCaseForm';
export const EMPLOYEE_FORM = 'employee';
export const EMPLOYEE_EMAIL_FORM = 'employeeEmailForm';
export const EMPLOYEE_ATTENDANCE_FORM = 'employeeAttendance';
export const EMPLOYEE_ATTENDANCE_CSV_FORM = 'downloadAttendanceCsvForm';
export const EMPLOYEE_PAY_FORM = 'employeePay';
export const EMPLOYEE_PAY_ROLLBACK_FORM = 'employeePayRollBack';
export const EMPLOYEE_PAY_ALL_ROLLBACK_FORM = 'employeePayAllRollback';
export const EMPLOYEE_PAY_CSV_FORM = 'employeePayCsv';
export const EMPLOYMENT_TYPE_FORM = 'employmentType';
export const POSITION_FORM = 'position';
export const OCCUPATION_FORM = 'occupation';
export const CLIENT_COMMUTING_FEE_SETTING_FORM = 'clientCommutingFeeSetting';
export const CLIENT_HEALTH_INSURANCE_FORM = 'clientHealthInsuranceForm';
export const CLIENT_PENSION_INSURANCE_FORM = 'clientPensionInsuranceForm';
export const CLIENT_EMPLOYMENT_INSURANCE_FORM = 'clientEmploymentInsuranceForm';
export const LOGIN_FORM = 'login';
export const CLIENT_ACCIDENT_INSURANCE_FORM = 'clientAccidentInsuranceForm';
export const CLIENT_TAX_CAL_METHOD_SETTING_FORM = 'clientTaxCalMethodSettingForm';
export const EMPLOYEE_ATTENDANCE_CSV_UPLOAD_FORM = 'employeeAttendanceCsvUploadForm';
export const CLIENT_ALLOWANCE_FORM = 'clientAllowanceForm';
export const CLIENT_UNIT_PRICE_FORM = 'clientUnitPriceForm';
export const INHABITANT_TAX_FB_DATA_FORM = 'inhabitantTaxFBDataForm';
export const PAYROLL_FB_DATA_FORM = 'payrollFBDataForm';
export const RESIDENT_TAX_PAYMENT_ADDRS_FORM = 'residentTaxPaymentAddrsForm';
export const CLIENT_BONUS_FORM = 'clientBonusForm';
export const EMPLOYEE_BONUS_FORM = 'employeeBonusForm';
export const MEMO_FORM = 'memoForm';
export const CLIENT_BONUS_ALLOWANCE_FORM = 'clientBonusAllowanceForm';
export const CONFIRM_PAYROLL_GROUP = 'confirmPayrollGroup';
export const UNCONFIRM_PAYROLL_GROUP = 'unconfirmPayrollGroup';
export const DOWNLOAD_BONUS_FB_FORM = 'downloadBonusFBForm';
export const MONTHLY_REVISION_FORM = 'standardMonthlyRevision';
export const NOTIFICATION_OF_BASE_AMOUNT_REVISION_FORM = 'standardMonthlyRevision';
export const CONFIRM_MONTHLY_REVISION_FORM = 'confirmMonthlyRevisionForm';
export const CONFIRM_NOTIFICATION_OF_BASE_AMOUNT_REVISION_FORM = 'confirmNotificationOfBaseAmountRevisionForm';
export const NOTIFICATION_OF_BASE_AMOUNT_REVISION_CSV_FORM = 'notificationOfBaseAmountRevisionCsvForm';
export const REPORT_LABOR_INSURANCE_SUMMARY_FORM = 'reportLaborInsuranceSummaryForm';
export const REPORT_LABOR_INSURANCE_DECLARATION_FORM = 'reportLaborInsuranceDeclarationForm';
export const REPORT_LABOR_INSURANCE_DECLARATION_INSURANCE_RATE_FORM = 'reportLaborInsuranceDeclarationInsuranceRateForm';
export const REPORT_LABOR_INSURANCE_DECLARATION_RECALCULATION_FORM = 'reportLaborInsuranceDeclarationRecalculationForm';
export const INCOME_TAX_DECLARATION_RESET_FORM = 'incomeTaxDeclarationResetForm';
export const REPORT_WITHHOLDING_SLIP_CONFIRM_FORM = 'reportWithholdingSlipForm';
export const EMPLOYEE_SEARCH_FORM = 'employeeSearchForm';
export const ROLE_FORM = 'roleForm';
export const ROLE_USER_FORM = 'roleUserForm';
export const INVITE_ACCOUNT_FORM = 'inviteAccountForm';

export const CONFIRM_CLIENT_BONUS = 'confirmClientBonus';
export const UNCONFIRM_CLIENT_BONUS = 'unconfirmClientBonus';
export const EMPLOYEE_BONUS_CSV_FORM = 'employeeBonusCsvForm';
export const EDITABLE_LIST_FIELDS_NAME = 'fields';
export const USER_PROFILE_FORM = 'userProfileForm';
export const USER_ACCOUNT_EMAIL_FORM = 'userAccountEmailForm';
export const USER_ACCOUNT_PASSWORD_FORM = 'userAccountPasswordForm';
export const RESET_PASSWORD_FORM = 'resetPasswordForm';

export const REPORT_HEALTH_INSURANCE_BONUS_FORM = 'reportHealthInsuranceBonusForm';
export const REPORT_EDIT_HEALTH_INSURANCE_BONUS_FORM = 'reportEditHealthInsuranceBonusItemForm';

export const CLIENT_ALLOWANCE_ITEM_FORM = 'clientAllowanceItemForm';
export const CLIENT_ALLOWANCES_DEDUCTIONS_EXPORT_FORM = 'clientAllowancesDeductionsExportForm';
export const CLIENT_CSV_FORMAT_FORM = 'clientCsvFormatForm';
export const PROCEDURE_FORM = 'procedureForm';
export const SYNC_JBC_SETTING_FORM = 'syncJbcSettingForm';
export const WAGE_LEDGER_EXPORT_ITEM_FORM = 'wageLedgerExportItemForm';
export const POLICY_FORM = 'policyForm';
export const EXPORT_TO_ROUMU = 'exportToRoumu';
export const IMPORT_FROM_ROUMU = 'importFromRoumu';
export const SETTING_PAYMENT_DATE = 'SettingPaymentDateRdxForm';
export const CHANGE_BONUS_RELEASE_DATE_FORM = 'ChangeBonusReleaseDateForm';
export const CHANGE_PAY_RELEASE_DATE_FORM = 'ChangePayReleaseDateForm';
export const ALLOWED_IP_FORM = 'AllowedIpForm';
export const BONUS_REPORTS_CREATE_FORM = 'BonusReportsCreateForm';
export const BONUS_REPORTS_DOWNLOAD_FORM = 'BonusReportsDownloadForm';
export const PAY_REPORTS_CREATE_FORM = 'PayReportsCreateForm';
export const PAY_REPORTS_DOWNLOAD_FORM = 'PayReportsDownloadForm';
export const EXPORT_PND_FORM = 'ExportPndForm';
export const EXPORT_SSO_FORM = 'ExportSsoForm';
export const COMPANY_FORM = 'CompanyForm';
export const KT20_KOR_FORM = 'Kt20KorForm';
export const WITHHOLDING_REPORTS_CREATE_FORM = 'WithholdingReportsCreateForm';
export const WITHHOLDING_REPORTS_DOWNLOAD_FORM = 'WithholdingReportsDownloadForm';
export const SYNC_COMMON_ID_SETTING_FORM = 'syncCommonIdSettingForm';
export const DESK_SSO_RATE_FORM = 'deskSsoRateForm';
export const CONTRIBUTION_RATES_AND_INDUSTRY_CODE_SETTING_FORM = 'ContributionRateAndIndustryCodeSettingForm';
export const EXPORT_PND_KOR_FORM = 'ExportPndKorForm';

export const DOCUMENT_TYPE = 'documentType';
export const CUSTOM_FEATURE_FORM = 'customFeature';
export const SYNC_ATTENDANCE_FORM = 'syncAttendanceForm';

export const USER_WITHHOLDING_REPORTS_FORM = 'UserWithholdingReportsForm';
export const TAX_DEDUCTION_CERT_EDIT_FORM = 'taxDeductionCertEditForm';
export const PAYROLL_ACTION_SECTION = 'payrollActionSection';
